var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._l((_vm.tags),function(term){return _c('span',{key:term,staticClass:"term"},[_c('router-link',{attrs:{"to":_vm.termFilterHref(term)}},[_vm._v(_vm._s(term))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }